
import { ref, nextTick } from 'vue'

import type {
    UploadInstance,
    UploadProps,
} from "element-plus";

//services
import JwtService from "@/core/services/JwtService";
import { showNotification } from "@/core/config/Tools"

export default {
    props: {
        extens: {
            type: String,
            required: true,
            default: ""
        },
        allowedMIMEs: {
            type: Array as () => string[],
            required: true,
            default: () => ['application/pdf', 'image/png', 'image/jpeg'], // Valores predeterminados
        },
        maxFileSizeMB: {
            type: Number, // Tamaño máximo permitido en MB
            required: true,
            default: 5, // 5 MB por defecto
        },
        paramsUpload : {
            type: Object,
            required: true,
            default: {}
        }
    },
    emits: ["uploadResponse"],
    setup(props, { emit }) {
        const dialogUpload = ref(false)
        const dataUpload = ref<any>({})
        const urlUpload = ref(process.env.VUE_APP_API_URL)
        const maxFileSizeInBytes = props.maxFileSizeMB * 1024 * 1024;
        const upload = ref<UploadInstance>()
        const headers = ref({
            Authorization: `Bearer ${JwtService.getToken()}`,
            'X-Company': JwtService.getCompany()
        })

        const openModal = () => {
            dialogUpload.value = true
        }

        const onOpened = () => {
            dataUpload.value = props.paramsUpload
        }

        const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
            if (!props.allowedMIMEs.includes(rawFile.type)) {
                showNotification({title: 'Error', message: '¡El archivo no tiene el formato permitido!', status: 'error'})
                return Promise.resolve(false);
            } else if (rawFile.size > maxFileSizeInBytes) {
                showNotification({title: 'Error', message: `El archivo supera el tamaño máximo permitido de ${props.maxFileSizeMB} MB.`, status: 'error'})
                return Promise.resolve(false);
            }
            return Promise.resolve(true);
        };

        const isJSON = (str: string): boolean => {
            try {
                JSON.parse(str);
                return true;
            } catch {
                return false;
            }
        }

        const handleError: UploadProps['onError'] = (error: Error, uploadFile) => {
            setTimeout(() => {
                let errorMessage = 'Error desconocido.';
                if (isJSON(error.message)) {
                    const errorData = JSON.parse(error.message);
                    errorMessage = errorData.message || errorMessage;
                } else {
                    errorMessage = error.message || errorMessage;
                }
                showNotification({ title: "Error", message: errorMessage, status: "error" })
            }, 100);
        }

        const handleSuccess: UploadProps['onSuccess'] = async (response, uploadFile) => {
            if(response.status == 'success'){
                await nextTick();  // Espera a que Vue termine el ciclo de renderizado
                dialogUpload.value = false;
            }
            showNotification(response)
            emit("uploadResponse", response)
        }

        const onClosed = () => {
            setTimeout(() => {
                upload.value?.clearFiles();
                dataUpload.value = {};
            }, 300);
        }

        return {
            dialogUpload,
            dataUpload,
            upload,
            headers,
            urlUpload,
            //methods
            handleError,
            beforeUpload,
            handleSuccess,
            onClosed,
            onOpened,
            openModal

        }

    },
}
